import React, { useImperativeHandle, useRef, useState } from "react";
import { ReusableModal } from "ui/molecules/modal/ReusableModal";
import { ResidentModel } from "app/services/api/types/residents/models/ResidentModel";
import { ModifyResidentRef } from "app/features/residents/templates/interfaces";
import { View } from "ui/atoms/view";
import { Button, ButtonText } from "ui/gluestack/button";
import { ResidentProvider } from "app/features/residents/provider/ResidentProvider";
import { ResidentBioFormTemplate } from "app/features/residents/templates/modify/ResidentBioFormTemplate";
import { ResidentAssessmentFormTemplate } from "../modify/ResidentAssessmentFormTemplate";
import { FormButtons } from "../../molecules/FormButtons";

interface Ref {
  show: (initialResident?: ResidentModel) => void;
}

const EditResidentAssessmentModal = React.forwardRef<Ref, unknown>((_, ref) => {
  const [showing, setShowing] = useState(false);
  const [initialResident, setInitialResident] = useState<ResidentModel>();
  const editResidentRef = useRef<ModifyResidentRef>(null);

  useImperativeHandle(ref, () => ({
    show: (initialResident?: ResidentModel) => {
      setInitialResident(initialResident);
      setShowing(true);
    },
  }));

  const handleClose = () => {
    setShowing(false);
  };

  const handleSave = async () => {
    const resp = await editResidentRef.current?.continue();
    if (resp) setShowing(false);
  };

  return (
    <ReusableModal
      isVisible={showing}
      onClose={handleClose}
      className="w-full max-w-[984px] mx-auto"
      title="Resident Assesment"
      hasCancelButton
      isEditing
    >
      <>
        <ResidentProvider residentModel={initialResident}>
          <ResidentAssessmentFormTemplate ref={editResidentRef} />

          <FormButtons onClose={handleClose} onSave={handleSave} />
        </ResidentProvider>
      </>
    </ReusableModal>
  );
});

EditResidentAssessmentModal.displayName = "EditResidentAssessmentModal";
export { EditResidentAssessmentModal };
